import { useState } from 'react';
import cancelLoanApplication from '../api/bank/cancelLoanApplication';
import Button from './Button/Button';
import Modal from './Modal/Modal';
import DocsInputNew from './Inputs/DocsInput/DocsInputNew';
import alert from '../helpers/alert';
import uploadDocumentToDeal from '../api/deals/uploadDocumentToDeal';
import { DOCUMENT_TYPES_VEHICLE_RETURN_CONFIRMATION_LETTER } from '../constants';
import LoaderInline from './Loader/LoaderInline';

const CancelCreditFunding = ({ buttonText = 'ÐÑÐ¼ÐµÐ½Ð¸ÑÑ Ð·Ð°ÑÐ²ÐºÑ Ð¸ ÑÐ¸Ð½Ð°Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ', dealId, bankOwnerId, chunkId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!document || !dealId || !chunkId || !bankOwnerId) {
      const errors = {
        document: 'ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
        dealId: 'ÐÐµ Ð½Ð°Ð¹Ð´ÐµÐ½ ID ÑÐ´ÐµÐ»ÐºÐ¸',
        chunkId: 'ÐÐµ Ð½Ð°Ð¹Ð´ÐµÐ½ chunkId',
        bankOwnerId: 'ÐÐµ Ð½Ð°Ð¹Ð´ÐµÐ½ bankOwnerId'
      };
      return alert.error(errors[Object.keys({ document, dealId, chunkId, bankOwnerId }).find(key => !eval(key))]);
    }
    setLoading(true);
    try {
      await uploadDocumentToDeal({
        dealId,
        fileTypeId: DOCUMENT_TYPES_VEHICLE_RETURN_CONFIRMATION_LETTER,
        file: document,
      });

      await cancelLoanApplication({ bankOwnerId, chunkId });
      alert.success('ÐÐ°ÑÐ²ÐºÐ° ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¼ÐµÐ½ÐµÐ½Ð°');
      setIsOpen(true);
    } catch (e) {
      alert.error(e?.response?.data?.message || 'ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¾ÑÐ¼ÐµÐ½Ðµ Ð·Ð°ÑÐ²ÐºÐ¸');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button fill onClick={() => setIsOpen(true)}>
        {buttonText}
      </Button>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        contentStyle={{
          maxHeight: 300,
          maxWidth: 520,
        }}
        title="ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ Ð¾ÑÐ¼ÐµÐ½Ð¸ÑÑ Ð·Ð°ÑÐ²ÐºÑ?"
      >
        {loading ? (
          <LoaderInline />
        ) : (
          <>
            <div
              style={{
                marginBottom: 20,
              }}
            >
              <DocsInputNew
                text="ÐÐ¸ÑÑÐ¼Ð¾ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð¾ Ð²Ð¾Ð·Ð²ÑÐ°ÑÐµ ÑÑÐ°Ð½ÑÐ¿Ð¾ÑÑÐ½Ð¾Ð³Ð¾ ÑÑÐµÐ´ÑÑÐ²Ð°"
                label="ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ"
                id="Ð¿Ð¸ÑÑÐ¼Ð¾"
                value={document}
                onChange={setDocument}
                required
              />
            </div>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gridGap: '10px',
                marginTop: 'auto',
              }}
            >
              <Button fill onClick={handleClick}>
                ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ
              </Button>
              <Button fill onClick={() => setIsOpen(false)}>
                ÐÑÐ¼ÐµÐ½Ð°
              </Button>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default CancelCreditFunding;
